import React, {Fragment, useEffect} from "react";

// reactstrap components
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText, Media,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import {clickImg, paginate} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import classnames from "classnames";
import {Link} from "react-router-dom";
import shopService from "./shop.service";
import { v4 as uuidv4 } from 'uuid';
import {shopCategory} from "./service/shop.category";

function ShopUserList({ history }) {
  const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
  const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
  const [data, setData] = useHistoryState([], 'data');

  const [category, setCategory] = useHistoryState('전체', 'category');
  const [active, setActive] = useHistoryState('전체', 'active');
  const [registerType, setRegisterType] = useHistoryState('전체', 'registerType');
  const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
  const [search, setSearch] = useHistoryState('', 'search');

  console.log(pageActive, pageCount)

  const render = async () => {
    try {
      const options = {
        category: category === 'Zero Waste' ? 'zeroWaste' : category,
        search,
        registerType
      }
      if (active !== '전체') {
        if (active) {
          console.log(active === '활성화');
          options.active = active === '활성화';
        }
      }
      const res = await shopService.list(options);
      console.log('상점프로필 유저 관리', res);
      if (res.code === 200) {
        setPageCount(res.list.length);
        setData(paginate(res.list, pageActive, 10));
      }
    } catch (e) {
      alert(e.response?.data?.resultMsg);
    }
  }

  useEffect(() => {
    render();
  }, [category, search, active, registerType, pageActive, pageCount]);

  const statusChange = async (id, active) => {
    const res = await shopService.update(id, {active});
    if (res.code === 200) {
      render();
    }
  }

  return (
    <>
      <SimpleHeader name="Tables" parentName="Tables" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <Row className="py-3">
                  <Col xs="11">
                    <Form>
                      <Row>
                        <Col xs="3">
                          <label className=" form-control-label py-2">
                          </label>
                          <FormGroup>
                            <InputGroup
                              className={classnames("input-group-merge", {
                                focused: searchCurrent,
                              })}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fas fa-search" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="이름, 핸드폰 번호로 검색"
                                type="text"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onFocus={(e) => setSearchCurrent(true)}
                                onBlur={(e) => setSearchCurrent(false)}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col xs="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="exampleFormControlSelect13"
                            >
                              카테고리
                            </label>
                            <Input
                              id="exampleFormControlSelect13"
                              type="select"
                              value={category}
                              onChange={(e) => setCategory(e.target.value)}
                            >
                              <option>전체</option>
                              {shopCategory.map((c, i) => {
                                return [
                                  <option key={i}>{c}</option>
                                ]
                              })}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xs="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="diff"
                            >
                              상태
                            </label>
                            <Input
                              id="diff"
                              type="select"
                              value={active}
                              onChange={(e) => setActive(e.target.value)}
                            >
                              <option>전체</option>
                              <option>비활성화</option>
                              <option>활성화</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xs="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="diff"
                            >
                              상점 프로필 등록 요청
                            </label>
                            <Input
                              id="diff"
                              type="select"
                              value={registerType}
                              onChange={(e) => setRegisterType(e.target.value)}
                            >
                              <option>전체</option>
                              <option>등록</option>
                              <option>수정</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
                <Row>
                  <Col xs="6">
                    <h3 className="mb-0">상점프로필 유저 관리</h3>
                  </Col>
                  <Col className="text-right" xs="6">
                    <Button
                      className="btn-round btn-icon"
                      color="default"
                      id="tooltip443412080"
                      onClick={(e) => history.push('/admin/shopRegister')}
                      size="sm"
                    >
                  <span className="btn-inner--icon mr-1">
                    <i className="fas fa-user-edit" />
                  </span>
                      <span className="btn-inner--text">등록하기</span>
                    </Button>
                  </Col>
                </Row>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive striped>
                <thead className="thead-light">
                <tr>
                  <th className="text-center">상점 프로필 등록 날짜</th>
                  <th className="text-center">아이디</th>
                  <th className="text-center">회원명</th>
                  <th className="text-center">카테고리</th>
                  <th className="text-center">업체명</th>
                  <th className="text-center">업체 대표 사진</th>
                  <th className="text-center">위치</th>
                  <th className="text-center">상점 프로필 등록 요청</th>
                  <th className="text-center">활성화</th>
                  <th className="text-center">메뉴 관리</th>
                  <th className="text-center">리뷰 관리</th>
                  <th className="text-center">쿠폰 관리</th>
                  <th />
                </tr>
                </thead>
                <tbody>
                  {data?.map((item, i) => {
                  return [
                    <Fragment key={uuidv4()}>
                      <tr>
                        <td className="text-center">
                          {item.createdAt}
                        </td>
                        <td className="text-center">
                          {item.userLoginId}
                        </td>
                        <td className="text-center">
                          {item.userName}
                        </td>
                        <td className="text-center">
                          {item.category}
                        </td>
                        <td className="text-center">
                          {item.name}
                        </td>
                        <td className="text-center">
                          <Media className="align-items-center">
                            <a
                              className="avatar rounded-circle"
                              href="#pablo"
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt="..."
                                style={{ height: 50 }}
                                onClick={() => clickImg(item.thumbnail)}
                                src={item.thumbnail}
                              />
                            </a>
                          </Media>
                        </td>
                        <td className="text-center">
                          {item.address + ' ' + item.addressDetail}
                        </td>
                        <td className="text-center">
                          {item.registerType}
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                              checked={item.active}
                              type="checkbox"
                              onChange={(e) => statusChange(item.id, !item.active)}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="No"
                              data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <Button
                            size='sm'
                            onClick={() => history.push('/admin/shopMenu/' + item.id)}
                          >
                            메뉴
                          </Button>
                        </td>
                        <td className="text-center">
                          <Button
                            size='sm'
                            onClick={() => history.push('/admin/shopReviewList/' + item.id)}
                          >
                            리뷰
                          </Button>
                        </td>
                        <td className="text-center">
                          <Button
                            size='sm'
                            onClick={() => history.push('/admin/couponList/' + item.id)}
                          >
                            쿠폰
                          </Button>
                        </td>
                        <td className="table-actions">
                          <Link className="table-action" to={'/admin/shopDetail/' + item.id}>
                            <i id={"tooltip" + i} className="fas fa-user-edit" />
                          </Link>
                          <UncontrolledTooltip delay={0} target={"tooltip" + i}>
                            상세 보기
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    </Fragment>
                  ];
                })}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <PaginationWrapper
                  isActive={pageActive}
                  pageNumber={pageCount}
                  callback={(page) => setPageActive(page)}
                  itemPerPage={10}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default ShopUserList;
